// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables for Instec */\n[data-v-aa9addb8]:export {\n  menuBg: #0F4C81;\n  menuText: #ffffff;\n  menuActiveText: #0F4C81;\n  menuActiveBg: #ffffff;\n}\n\n/* Mixins */\n@media (min-width: 1024px) {\n.el-form[data-v-aa9addb8],\n  .el-select[data-v-aa9addb8] {\n    width: 80%;\n}\n.el-input[data-v-aa9addb8],\n  .el-textarea[data-v-aa9addb8] {\n    max-width: 80%;\n}\n}\n.hidden[data-v-aa9addb8] {\n  display: none;\n}", ""]);
// Exports
module.exports = exports;
